import styled, { css } from 'styled-components';

import Text from '~components/Text';

const Active = css`
  & > svg > path {
    fill: #d63461;
    stroke: #d63461;
  }
`;

export const S = {
  Wrapper: styled.div`
    display: flex;
    gap: 10px;
    margin-left: auto;

    ${({ theme }) => theme.media.mobile} {
      margin: 20px 0 30px 0;
    }
  `,
  ButtonText: styled(Text)`
    color: ${({ theme }) => theme.colors.gray900};
  `,
  Button: styled.button<{ isActive: boolean }>`
    background: ${({ theme }) => theme.colors.gray300};
    border: none;
    box-sizing: border-box;
    border-radius: 100px;
    padding: 9.5px 30px;
    margin-left: auto;
    align-items: center;
    display: flex;

    & > svg {
      margin-right: 12px;
    }

    ${({ theme }) => theme.colors.gray800};
    ${(props) => props.isActive && Active}
  `,
};
